import React from 'react';
import { Star } from 'lucide-react';
import type { Testimonial } from '../../types';

interface TestimonialCardProps {
  testimonial: Testimonial;
}

export default function TestimonialCard({ testimonial }: TestimonialCardProps) {
  return (
    <div className="flex-shrink-0 w-[min(340px,85vw)] p-5 sm:p-6 rounded-2xl glass-light hover:scale-105 hover:shadow-xl transition-all duration-300 cursor-pointer card-shimmer card-shimmer-light card-glow card-glow-light overflow-hidden">
      {/* Stars */}
      <div className="flex gap-1 mb-3">
        {Array.from({ length: testimonial.rating }).map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-primary text-primary" />
        ))}
      </div>
      {/* Quote */}
      <p className="text-text-dark text-sm italic leading-relaxed mb-4">
        "{testimonial.quote}"
      </p>
      {/* Author */}
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold text-sm">
          {testimonial.name.charAt(0)}
        </div>
        <div>
          <p className="text-text-dark font-semibold text-sm">{testimonial.name}</p>
          <p className="text-text-gray text-xs">
            {testimonial.city} · {testimonial.role} · {testimonial.duration}
          </p>
        </div>
      </div>
    </div>
  );
}
